var React = require('react');

function CaretRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 18L35.122 18","stroke":"white","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M18.439 35.9999C18.439 26.3013 26.3013 18.439 35.9999 18.439","stroke":"white","strokeWidth":"3","key":1}),React.createElement("path",{"d":"M35.9999 17.561C26.3013 17.561 18.439 9.69872 18.439 5.96046e-05","stroke":"white","strokeWidth":"3","key":2})]);
}

CaretRight.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = CaretRight;

CaretRight.default = CaretRight;
